export default {
  requestPriceDetail: require('./requestPriceDetail'),
  selectAddOns: require('./selectAddOns'),
  selectDrinks: require('./selectDrinks'),
  selectMenu: require('./selectMenu'),
};
